import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { RepresentanteModalidadeComercialPipe } from './representante-modalidade-comercial.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RepresentanteModalidadeComercialPipe
    ],
    exports: [
        RepresentanteModalidadeComercialPipe
    ],
    providers: [
        RepresentanteModalidadeComercialPipe
    ]
})
export class RepresentanteModalidadeComercialPipeModule { }
